export default "<div class=\"web-layout\">\r\n    <router-outlet></router-outlet>\r\n</div>\r\n"